import { render, staticRenderFns } from "./UserPassTable.vue?vue&type=template&id=705d8d10&scoped=true"
import script from "./UserPassTable.vue?vue&type=script&lang=js"
export * from "./UserPassTable.vue?vue&type=script&lang=js"
import style0 from "./UserPassTable.vue?vue&type=style&index=0&id=705d8d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705d8d10",
  null
  
)

export default component.exports